import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs = [{
  q: 'How do I receive the package after I purchase?',
  a: 'You receive instant access to all the material so you can start using it immediately — no waiting, no complicated steps.'
}, {
  q: 'What experience level of coach is this designed for?',
  a: "This system works for coaches at all experience levels. Whether you're new to hybrid racing or experienced, the material is organized and ready-to-use. It includes beginner, intermediate and advanced progressions."
}, {
  q: 'Does this work for coaches in any country?',
  a: 'Yes. The system is designed for hybrid fitness racing coaches worldwide. The training principles, progressions and session structures work regardless of location.'
}, {
  q: 'Can I edit or customize the material?',
  a: 'The PDFs are designed to be practical and ready-to-use as-is. Customization depends on your license terms — check the included documentation for specifics.'
}, {
  q: 'What currency will I pay in?',
  a: 'You pay in your local currency. The amount adjusts automatically based on the country you are purchasing from.'
}, {
  q: "What if this doesn't work for me?",
  a: "You have 7 days to try everything. If the system doesn't meet your needs, we'll refund your full payment — no questions asked."
}, {
  q: 'Are there updates or new material added after I purchase?',
  a: 'Check the product documentation for details on updates and any ongoing support or additions.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-20 md:py-24 px-4 bg-ivory" data-id="element-103" data-mp="wyxl7h4p725p">
      <div className="max-w-3xl mx-auto" data-id="element-104" data-mp="iyms07fx1bhd">
        <div className="text-center mb-14" data-id="element-105" data-mp="izo2a9p3xty1">
          <h2 className="text-3xl md:text-5xl font-display font-bold uppercase text-charcoal" data-id="element-106" data-mp="mzyjkiico6s7">
            Frequently asked questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-107" data-mp="2po7w9dblcyts">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-white border border-sand-deep rounded-xl overflow-hidden shadow-sm" data-id="element-108" data-mp="2kuvmg9bkmwl3" data-mpi={index}>
              <h3 data-id="element-109" data-mp="2fuhfyvpmbup6">
                <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between gap-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-orange" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-110" data-mp="2ay0lzkvqmm46">
                  <span className="font-bold text-lg text-charcoal font-display uppercase" data-id="element-111" data-mp="2umhslr91y5gz">
                    {faq.q}
                  </span>
                  <ChevronDownIcon aria-hidden="true" className={`text-orange transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-112" data-mp="1n61zs5ur36c9" />
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-113" data-mp="7p72g7j9bqu0">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-114" data-mp="7ndtump32wjd">
                    <div className="px-6 pb-5 text-warmgray border-t border-sand-deep pt-4" data-id="element-115" data-mp="qgrkiflrkgt6">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}